var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { forwardRef, useEffect, useState } from 'react';
import { FAL_CARET, FAL_TIMES, FAR_TIMES } from '../../const/icons';
import i18n from '../../strings/i18n';
import { FirstNotification, NotificationContainer, RightIcon, SingleNotification } from './subcomponents';
import getChevronRightNotificationColor from '../../helpers/getChevronRightNotificationColor';
import getLanguageFromStorage from '../../helpers/getLanguageFromStorage';
import { notificationsEllipsisInEnglish, notificationsEllipsisInSpanish } from '../../const/ellipsisNotifications';
var notificationsDataAnalytics = {
    'data-analytics': 'clicktrackingevent',
    'data-object': 'button',
    'data-reason': 'Flip card',
    'data-type': 'Expand notifications'
};
var NotificationFront = function (_a, ref) {
    var notificationList = _a.notificationList, handleOnClick = _a.handleOnClick;
    if (!notificationList.length)
        return _jsx(_Fragment, {});
    var _b = notificationList[0], name = _b.name, notificationType = _b.notificationType, notificationIcon = _b.notificationIcon, _c = _b.fontAwesomeType, fontAwesomeType = _c === void 0 ? 'far' : _c, description = _b.description, subDescription = _b.subDescription;
    var shouldStartMinimized = [
        'introRateLoanExpiredNotify',
        'introRateLoanExpiringNotify',
        'loanApprovedStillProcessingNotify',
        'waivedInterestExpiredNotify',
        'waivedInterestExpiringNotify'
    ].includes(name);
    var _d = useState(shouldStartMinimized), isMinimized = _d[0], setIsMinimized = _d[1];
    var lang = getLanguageFromStorage();
    useEffect(function () {
        var _a;
        if (isMinimized && ref.current) {
            if (notificationList.length > 1) {
                ref.current.focus();
            }
            else {
                (_a = ref.current
                    .querySelector('#minimize-notification')) === null || _a === void 0 ? void 0 : _a.focus();
            }
        }
    }, [ref, isMinimized]);
    var isUrgent = ['pastDueNotify', 'attentionRequiredNotify'].includes(name);
    var isEllipsisInEnglish = notificationsEllipsisInEnglish.includes(name);
    var isEllipsisInSpanish = notificationsEllipsisInSpanish.includes(name);
    var isEllipsis = lang === 'en' ? isEllipsisInEnglish : isEllipsisInSpanish;
    if (isMinimized) {
        return notificationList.length > 1 ? (_jsx(NotificationContainer, { children: _jsx(FirstNotification, __assign({}, (notificationList.length > 1 && notificationsDataAnalytics), { onClickHandler: handleOnClick, type: notificationType, isTruncated: !isUrgent, notificationCount: notificationList.length, notificationCountLabel: i18n({
                    notifications: 'notifications'
                }), icon: _jsx(FontAwesomeIcon, { icon: [fontAwesomeType, notificationIcon], size: "lg" }), title: description, dataType: "Flip card", ref: ref })) })) : (_jsx(NotificationContainer, __assign({ "data-analytics": "clicktrackingevent", "data-object": "button", "data-reason": "Flip card", "data-type": "Expand notifications", onClick: handleOnClick }, { children: _jsx(SingleNotification, { type: notificationType, isTruncated: !isUrgent, icon: _jsx(FontAwesomeIcon, { icon: [fontAwesomeType, notificationIcon], size: "lg" }), title: _jsxs(_Fragment, { children: [description, notificationList.length === 1 && !isEllipsis && (_jsx(RightIcon, { id: "minimize-notification", onClick: handleOnClick, restIcon: _jsx(FontAwesomeIcon, { icon: FAL_CARET, color: getChevronRightNotificationColor(notificationType) }), activeIcon: _jsx(FontAwesomeIcon, { icon: FAL_CARET, color: getChevronRightNotificationColor(notificationType) }), type: "button", ariaLabel: i18n({
                                notifications: 'minimizeNotification'
                            }) }))] }), dataType: "Flip card", ref: ref }) })));
    }
    return (_jsx(NotificationContainer, { children: _jsx(FirstNotification, __assign({ onClickHandler: handleOnClick, type: notificationType, isTruncated: !isUrgent, notificationCount: isUrgent ? 0 : notificationList.length }, ((notificationList.length > 1 && !isUrgent) || isEllipsis
            ? notificationsDataAnalytics
            : {}), { notificationCountLabel: i18n({
                notifications: 'notifications'
            }), icon: _jsx(FontAwesomeIcon, { icon: [fontAwesomeType, notificationIcon], size: "lg" }), title: _jsxs(_Fragment, { children: [description, isUrgent && (_jsx(RightIcon, { id: "minimize-notification", onClick: function () {
                            setIsMinimized(true);
                        }, restIcon: _jsx(FontAwesomeIcon, { icon: FAL_TIMES }), activeIcon: _jsx(FontAwesomeIcon, { icon: FAR_TIMES }), type: "button", ariaLabel: i18n({ notifications: 'minimizeNotification' }) }))] }), subTitle: subDescription, dataType: "Flip card", ref: ref })) }));
};
export default forwardRef(NotificationFront);
